import Commandes from '../components/Commandes';
export default function PrepaCommandes() {
    return <>
        <Commandes />
    </>
}